import { createSelector } from 'reselect';
import { ApplicationState } from '../types';

export const getShoppingCart = ({ shoppingCart }: ApplicationState) =>
  shoppingCart;
/**
 * Simple selector to extract newFunds array.
 * @param state
 * @returns {(UserFund & AllFund)[]} Funds added to new fund list, which has props from UserFund and AllFund, but not
 * data generated by the available funds selector yet.
 */
export const getNewFunds = createSelector(
  [getShoppingCart],
  ({ newFunds }) => newFunds
);

/**
 * Simple selector to extract cartLookup from shopping cart.
 * @param state
 * @returns {CartLookup}
 */
export const getCartLookup = createSelector(
  [getShoppingCart],
  ({ cartLookup }) => cartLookup
);
